import { FormattedMessage } from "react-intl"

const MeasurementRadioButtons = ({ style, toggleMeasurement }) => {
  return (
    <div className="form-row">
      <label>
        <input
          type="radio"
          name="measurement"
          value="imperial"
          style={style}
          onChange={toggleMeasurement}
          defaultChecked
        />
        <FormattedMessage id="togo.units.inches" />
      </label>
      &nbsp;
      &nbsp;
      <label>
        <input
          type="radio"
          name="measurement"
          value="metric"
          onChange={toggleMeasurement}
          style={style}
        />
        <FormattedMessage id="togo.units.centimeters" />
      </label>
    </div>
  )
}

export default MeasurementRadioButtons
